import React, { useEffect, useState } from "react";

import Layout from "../components/Layout/Layout";
import NavBar from '../components/NavBar/NavBar';

import friendsIcon from '../assets/friends.png';
import telegramUser from '../assets/telegramUser.png';
import telegramPremium from '../assets/telegramPremium.png';
import coinIcon from '../assets/coin2.png';

import { getProfile } from '../api/getProfile';

import { handleInvite } from "../utils/handleInvite";
import { formatNumber } from "../utils/formatNumber";

const Invite = () => {
    const normalReferralCount = +sessionStorage.getItem('normalReferralCount');
    const premiumReferralCount = +sessionStorage.getItem('premiumReferralCount');
    const referralBonus = formatNumber(normalReferralCount * 1500 + premiumReferralCount * 30000);

    const [memberData, setMemberData] = useState([]);

    // useEffect
    useEffect(()=>{
        const getFriendsInfo = async () => {
            const token = sessionStorage.getItem('token');

            const data = await getProfile(token);
            let friends = data.friends;
            let arr = [];
            friends.map(friend=>{
                let score = friend.score;
                let userName = '@' + friend.userName;
                let scoreText = score > 1000 ? `${score/1000}k+` : `${score}`;
                arr.push({id: userName, scoreText});
            })
            setMemberData(arr);
        }
        getFriendsInfo();
    }, [])

    const handleInviteClick = async () => {
        const chatId = sessionStorage.getItem('chatId');
        const userName = sessionStorage.getItem('userName');
        await handleInvite(chatId, userName);
        if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.close) {
            window.Telegram.WebApp.close();
        } else {
            console.error('Telegram WebApp API is not available.');
        }
    }

    return (
        <Layout>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                <img src={friendsIcon} alt="Friends Icon" style={{ marginTop: '1.5625rem', width: '6.25rem', height: '6.25rem' }} />
                <span style={{ color: 'white', fontFamily: 'Poppins', fontSize: '1.75rem', fontWeight: '600' }}>{normalReferralCount + premiumReferralCount} Friend{normalReferralCount + premiumReferralCount!==1?'s':""}</span>
                <div style={{ width: '88%', paddingInline: '1rem'}}>
                    <button style={{ width: '100%', background: 'rgba(140,140,140,0.1)', paddingBlock: '1.125rem', border: 'none', marginTop: '0.5rem', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '1.125rem' }}>
                        +{referralBonus} Mooncoins
                    </button>
                    <div style={{ marginTop: '19px', display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <span style={{ color: '#0F7EFE', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.125rem', textAlign:'center' }}>Invite friends to get Mooncoins.</span>
                    </div>
                    <div style={{ marginTop: '12px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '1rem' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <img src={telegramUser} alt="Telegram User" style={{ width: '3rem', height: '3rem' }} />
                                <span style={{ marginTop: '0.5rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem', color: 'white' }}>Telegram User</span>
                                <span style={{ marginTop: '0.25rem', fontFamily: 'Poppins', fontWeight: '700', fontSize: '1.25rem', color: '#0064D7', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>1,500</span>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <img src={telegramPremium} alt="Telegram Premium" style={{ width: '3rem', height: '3rem' }} />
                                <span style={{ marginTop: '0.5rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem', color: 'white' }}>Premium User</span>
                                <span style={{ marginTop: '0.25rem', fontFamily: 'Poppins', fontWeight: '700', fontSize: '1.25rem', color: '#0064D7', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>30,000</span>
                            </div>
                        </div>
                        <div style={{ marginTop: '1.25rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.125rem', color: 'white' }}>For you and a friend</div>
                    </div>
                    <button style={{ width: '100%', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.9rem', border: 'none', marginTop: '19px', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '0.9rem', cursor: 'pointer', fontWeight: '600' }} onClick={handleInviteClick}>
                        Invite a Friend
                    </button>
                    {
                        memberData.length?<div style={{ marginTop: '19px', marginBottom: '0.8rem', width: '100%', maxHeight: '20rem', overflow:'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '1.6875rem' }}>
                        {
                            memberData.map(item => (
                                <div key={item.userId} style={{ display: 'flex', alignItems: 'center',marginBottom:"0.8rem", width: '100%', justifyContent: 'space-between' }}>
                                    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column'}}>
                                        <img src={coinIcon} alt="Friends" style={{height:"3rem", width:"3rem"}}/>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '1rem', gap: '0.3125rem', width: '100%' }}>
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.9rem', color: 'white' }}>{item.id}</span>
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.8rem', color: 'white', opacity: '0.6' }}>{item.scoreText}</span>
                                    </div>
                                </div>
                            ))
                        }
                        </div>:''
                    }
                </div>
            </div>
            <div style={{height: '80px'}}></div>
            <NavBar />
        </ Layout >
    );
};

export default Invite;